<template>
  <div v-if="paymentMethodsAvailable" class="full-width">
    <InvoiceBalance
      v-for="invoice in invoices"
      :key="invoice.id"
      class="full-width mb-4"
      :invoice="invoice"
      @pay-balance="emit('pay-balance', $event)"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";

import API from "@/api-client";
import InvoiceBalance from "@/modules/paymentMethods/components/InvoiceBalance.vue";
import usePaymentMethods from "@/modules/paymentMethods/usePaymentMethods";

const reportPath = "/reports/consumer/invoices.json";
const reportParams = {
  page: 1,
  per_page: 10,
  sort_by: "id",
  sort_desc: true,
  balance_due: true
};

const invoices = ref([]);

const emit = defineEmits(["pay-balance"]);

async function fetchData() {
  const response = await API.makeRequest(reportPath, {
    method: "GET",
    params: reportParams
  });
  invoices.value = response.data.data;
}

onMounted(() => fetchData());

const { definePaymentCallbacks, paymentMethodsAvailable } = usePaymentMethods();
definePaymentCallbacks({
  onPaymentSuccess: fetchData
});
</script>

<style lang="scss"></style>
